<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_ADD_NOTES_TO_SHIFT</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <textarea class="form-control rounded" placeholder="" [(ngModel)]="RequestModel.Notes" maxlength="1000"></textarea>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="DisableModalOpenEvent = false; SubmitNotes()" translate>BTN.BTN_OK</button>
        <button type="button" class="btn btn-secondary" (click)="d('close')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>
